import { Box } from '@chakra-ui/react';
import moment from 'moment';

import { StandsItem, UserInfo } from '@app/api/models';
import { FieldView, Txt } from '@app/components/common';
import { TableColumn, dateTimeBodyRender } from '@app/components/common/table';
import GalleryModal from '@app/components/common/modals/gallery';
import { USER_DATE_FORMAT } from '@app/utils';

export const standsColumns: TableColumn<StandsItem>[] = [
  {
    name: 'id',
    label: 'ID',
    options: {
      filter: true,
      sort: false,
    },
  },
  {
    name: 'type_activity',
    label: 'Тип',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (value, rowData) => {
        return <>{value || '-'}</>;
      },
    },
  },
  {
    name: 'visit_date',
    label: 'Дата визита',
    options: {
      filter: {
        type: 'date',
        name: 'visit_date',
      },
      sort: true,
      customBodyRender: dateTimeBodyRender(false, true),
    },
  },
  {
    name: 'id',
    label: 'Стойка',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (_, { rowData }) => {
        return <Box display='flex' gap={0} flexDirection='column'>
          <FieldView title="Бренд" value={rowData.brand?.name} direction='row' />
          <FieldView title="Модель" value={rowData.model?.name} direction='row' />
          <FieldView title="Производитель" value={rowData.manufacturer?.name} direction='row' />
          <FieldView title="Дата установки" value={moment(rowData.mount_dt).format(USER_DATE_FORMAT)} direction='row' />
        </Box>;
      }
    }
  },
  {
    name: 'update_dt',
    label: 'Дата обновления',
    options: {
      filter: false,
      sort: false,
      customBodyRender: dateTimeBodyRender(),
    }
  },
  {
    name: 'images',
    label: 'Фото',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: Array<any>) => {
        return <GalleryModal  images={value || []} title="Фото" />;
      },
    },
  },
  {
    name: 'user',
    label: 'Пользователь',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: UserInfo, { rowData }) => {
        return <>{value?.full_name}</>;
      },
    },
  },
];